/* tslint:disable */
/* eslint-disable */
/**
 * PanKanapka
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    OrderMenu,
    OrderMenuFromJSON,
    OrderMenuFromJSONTyped,
    OrderMenuToJSON,
} from './';

/**
 * 
 * @export
 * @interface OrderMenuDataFrame
 */
export interface OrderMenuDataFrame {
    /**
     * 
     * @type {number}
     * @memberof OrderMenuDataFrame
     */
    count: number;
    /**
     * 
     * @type {number}
     * @memberof OrderMenuDataFrame
     */
    offset: number;
    /**
     * 
     * @type {number}
     * @memberof OrderMenuDataFrame
     */
    limit: number;
    /**
     * 
     * @type {Array<OrderMenu>}
     * @memberof OrderMenuDataFrame
     */
    data: Array<OrderMenu>;
}

export function OrderMenuDataFrameFromJSON(json: any): OrderMenuDataFrame {
    return OrderMenuDataFrameFromJSONTyped(json, false);
}

export function OrderMenuDataFrameFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderMenuDataFrame {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'offset': json['offset'],
        'limit': json['limit'],
        'data': ((json['data'] as Array<any>).map(OrderMenuFromJSON)),
    };
}

export function OrderMenuDataFrameToJSON(value?: OrderMenuDataFrame | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'offset': value.offset,
        'limit': value.limit,
        'data': ((value.data as Array<any>).map(OrderMenuToJSON)),
    };
}


